export default "__VITE_ASSET__61cb9748__"